class FilteredResults {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.grid = element.querySelector('#filtered-results__grid');
    this.items = [];
    this.inputsParent = element.querySelector('#filtered-results__inputs');
    this.inputs = element.querySelectorAll('.filter__input');

    if (!this.inputs) {
      throw new ReferenceError('No Filter Inputs Found');
    }

    if (!this.grid) {
      throw new ReferenceError('No element with #filtered-results__grid found');
    }

    this.initItems();
    this.bindEventHandlers();
  }

  initItems() {
    this.items = [...this.element.querySelectorAll("[class^='rfx-col']")];
  }

  bindEventHandlers() {
    this.inputs.forEach((input) => input.addEventListener("change", this.changeFiltered.bind(this)));
  }

  changeFiltered(event) {
    const selectedValue = event.target.value ?? null;

    if(typeof selectedValue !== "undefined" && selectedValue && selectedValue.length) {
      this.grid.innerHTML = "";

      const newItems = [...this.items]
        .filter(this.filterOutItems.bind({selectedValue}))
        .map(this.fixCssClass);

      if(newItems.length > 0){
        newItems.forEach((el) => this.grid.insertAdjacentElement("beforeend", el));
      } else {
        this.grid.insertAdjacentHTML("beforeend", `
          <div class="rfx-col-12" style="text-align: center;">
            <h2>No Results Found</h2>
          <div>
        `)
      }
    } else {
      const newItems = [...this.items].map(this.fixCssClass);

      newItems.forEach((el) => this.grid.insertAdjacentElement("beforeend", el));
    }
  }

  filterOutItems(item, idx) {
    const groupID = parseInt(this.selectedValue);

    if(isNaN(groupID) || typeof item.dataset.groupIds === "undefined"){
      return false;
    }

    const itemGroupIds = item.dataset.groupIds.split(",").map(Number);

    return itemGroupIds.includes(groupID);
  }

  fixCssClass(item, idx) {
    item.classList.remove("rfx-col-lg-4");

    if(idx > 1) {
      item.classList.add("rfx-col-lg-4");
    }

    return item;
  }
}

export default FilteredResults;
